import { type IProductHeaderProductInfo, Icon } from '~/index'
import * as C from './product-header-product-info.styles'

export function ProductHeaderProductInfo({
  brand,
  manufacturer,
  measurament,
  hasIcon,
  brandIcon,
  measuramentIcon,
  manufacturerIcon,
  testID,
}: IProductHeaderProductInfo) {
  return (
    <C.ProductInfo hasIcon={hasIcon} testID={testID}>
      {hasIcon && <Icon size="tiny" symbol={brandIcon} />}
      <C.ProductInfoText numberOfLines={1} hasIcon={hasIcon}>
        {brand}
      </C.ProductInfoText>
      {hasIcon ? (
        <Icon size="tiny" symbol={measuramentIcon} />
      ) : (
        <C.ProductInfoMark>•</C.ProductInfoMark>
      )}
      <C.ProductInfoText numberOfLines={1} hasIcon={hasIcon}>
        {measurament}
      </C.ProductInfoText>
      {hasIcon ? (
        <Icon size="tiny" symbol={manufacturerIcon} />
      ) : (
        <C.ProductInfoMark>•</C.ProductInfoMark>
      )}
      <C.ProductInfoText numberOfLines={1} hasIcon={hasIcon}>
        {manufacturer}
      </C.ProductInfoText>
    </C.ProductInfo>
  )
}
